function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ea636bfa-2217-403c-bc48-6b735fa6fbb7",
  x1: 95,
  y1: 44.91,
  x2: 95,
  y2: 4.69,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c0c5c0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d4d9d3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f70c412e-83a8-46b0-a4fc-845213855755",
  y1: 115.31,
  y2: 47.81,
  xlinkHref: "#ea636bfa-2217-403c-bc48-6b735fa6fbb7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f6e529ff-eadc-40d4-be5e-fb2a7ac942ca",
  x1: -156.58,
  y1: 24.8,
  x2: -138.15,
  y2: 24.8,
  gradientTransform: "matrix(1, 0, 0, -1, 323.15, 49.6)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c0c5c0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bb033e55-9792-4ed7-9cdf-cbc9b0118e77",
  x1: -156.58,
  y1: 81.56,
  x2: -138.15,
  y2: 81.56,
  gradientTransform: "matrix(1, 0, 0, -1, 323.15, 163.12)",
  xlinkHref: "#f6e529ff-eadc-40d4-be5e-fb2a7ac942ca"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a946cd15-edde-45a0-a7b1-a58230f294fb",
  x1: -167.64,
  y1: 24.8,
  x2: -149.21,
  y2: 24.8,
  gradientTransform: "translate(172.64)",
  xlinkHref: "#f6e529ff-eadc-40d4-be5e-fb2a7ac942ca"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bb24b2ff-3ffc-41b2-9d27-32635903b993",
  x1: -167.64,
  y1: 81.56,
  x2: -149.21,
  y2: 81.56,
  gradientTransform: "translate(172.64)",
  xlinkHref: "#f6e529ff-eadc-40d4-be5e-fb2a7ac942ca"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Artboard 3");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 7.13,
  y: 45.82,
  width: 175.75,
  height: 1.98,
  fill: "#c2c7c2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.6,4.69H181.4a3.6,3.6,0,0,1,3.6,3.6V44.91a0,0,0,0,1,0,0H5a0,0,0,0,1,0,0V8.29A3.6,3.6,0,0,1,8.6,4.69Z",
  fill: "url(#ea636bfa-2217-403c-bc48-6b735fa6fbb7)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5,47.81H185a0,0,0,0,1,0,0v63.9a3.6,3.6,0,0,1-3.6,3.6H8.6a3.6,3.6,0,0,1-3.6-3.6V47.81A0,0,0,0,1,5,47.81Z",
  fill: "url(#f70c412e-83a8-46b0-a4fc-845213855755)"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 44.84,
  width: 180,
  height: 1,
  fill: "#939598"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 30.25,
  y: 22.7,
  width: 63.75,
  height: 63.75,
  rx: 8.5,
  fill: "#e8ede6"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M36.5,79V74h.83v5Z",
  fill: "#231f20"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M38.12,74h1.51a2.21,2.21,0,0,1,.87.13,1.51,1.51,0,0,1,.54.43,2.24,2.24,0,0,1,.38.79,4.57,4.57,0,0,1,.14,1.21,4.2,4.2,0,0,1-.14,1.13,2.34,2.34,0,0,1-.38.76,1.58,1.58,0,0,1-.54.42,2.12,2.12,0,0,1-.82.14H38.12Zm.83.85v3.31h.62a1.68,1.68,0,0,0,.58-.07.66.66,0,0,0,.29-.23,1.22,1.22,0,0,0,.19-.48,4.77,4.77,0,0,0,0-1.74,1.21,1.21,0,0,0-.24-.51.8.8,0,0,0-.39-.24,3.41,3.41,0,0,0-.68,0Z",
  fill: "#231f20"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M42.41,76.37v-1h.79v1Zm0,2.67v-1h.79v1Z",
  fill: "#231f20"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M46.93,74a1.12,1.12,0,0,1,1,.57,5.54,5.54,0,0,1,0,4,1.12,1.12,0,0,1-1,.57,1.1,1.1,0,0,1-1-.57,5.54,5.54,0,0,1,0-4A1.09,1.09,0,0,1,46.93,74Zm0,.8c-.15,0-.28.1-.37.31a7.58,7.58,0,0,0,0,2.9c.09.21.22.31.37.31s.28-.1.38-.31a8.15,8.15,0,0,0,0-2.9C47.21,74.91,47.09,74.81,46.93,74.81Z",
  fill: "#231f20"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M50.12,74a1.12,1.12,0,0,1,1,.57,5.54,5.54,0,0,1,0,4,1.1,1.1,0,0,1-1.93,0,5.54,5.54,0,0,1,0-4A1.12,1.12,0,0,1,50.12,74Zm0,.8c-.15,0-.27.1-.37.31a7.58,7.58,0,0,0,0,2.9c.1.21.22.31.37.31s.29-.1.38-.31a7.58,7.58,0,0,0,0-2.9C50.41,74.91,50.28,74.81,50.12,74.81Z",
  fill: "#231f20"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M53.32,74a1.1,1.1,0,0,1,1,.57,5.54,5.54,0,0,1,0,4,1.1,1.1,0,0,1-1,.57,1.12,1.12,0,0,1-1-.57,5.54,5.54,0,0,1,0-4A1.12,1.12,0,0,1,53.32,74Zm0,.8c-.16,0-.28.1-.38.31a8.15,8.15,0,0,0,0,2.9c.1.21.22.31.38.31s.28-.1.37-.31a7.58,7.58,0,0,0,0-2.9C53.6,74.91,53.47,74.81,53.32,74.81Z",
  fill: "#231f20"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M57.19,79h-.78V75.42a2.87,2.87,0,0,1-1,.73v-.87a2.25,2.25,0,0,0,.68-.48,2,2,0,0,0,.49-.79h.63Z",
  fill: "#231f20"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M63.33,79V74h1.33a4.07,4.07,0,0,1,1,.07,1.11,1.11,0,0,1,.6.5,1.79,1.79,0,0,1,.24,1,1.84,1.84,0,0,1-.21.92,1.14,1.14,0,0,1-.51.51,2.63,2.63,0,0,1-1.06.15h-.54V79Zm.83-4.16V76.3h.46a2.26,2.26,0,0,0,.63-.06.57.57,0,0,0,.27-.24.76.76,0,0,0,.1-.41.69.69,0,0,0-.11-.42.46.46,0,0,0-.27-.23,2.34,2.34,0,0,0-.68-.06Z",
  fill: "#231f20"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M67.13,79V74H68v5Z",
  fill: "#231f20"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M68.76,79V74h.81l1.68,3.35V74H72v5h-.83l-1.65-3.27V79Z",
  fill: "#231f20"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M73,76.37v-1h.79v1ZM73,79v-1h.79v1Z",
  fill: "#231f20"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M78.25,79h-.79V75.42a2.71,2.71,0,0,1-1,.73v-.87a2.13,2.13,0,0,0,.68-.48,1.78,1.78,0,0,0,.49-.79h.64Z",
  fill: "#231f20"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M82.08,78.15V79H79.32a2.65,2.65,0,0,1,.27-1,6.51,6.51,0,0,1,.89-1.2,7,7,0,0,0,.64-.8,1.15,1.15,0,0,0,.17-.61.7.7,0,0,0-.14-.49.48.48,0,0,0-.39-.17c-.35,0-.54.26-.56.78l-.78-.09a1.75,1.75,0,0,1,.42-1.13,1.27,1.27,0,0,1,.94-.36,1.17,1.17,0,0,1,1,.42,1.57,1.57,0,0,1,.32,1A2,2,0,0,1,82,76a2.47,2.47,0,0,1-.26.58,4.5,4.5,0,0,1-.58.75c-.25.28-.41.47-.48.56a1.28,1.28,0,0,0-.16.27Z",
  fill: "#231f20"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M82.59,77.71l.76-.11a1,1,0,0,0,.19.54.49.49,0,0,0,.39.19.52.52,0,0,0,.41-.22,1,1,0,0,0,.17-.62.9.9,0,0,0-.16-.57.49.49,0,0,0-.39-.21,1.08,1.08,0,0,0-.36.07l.08-.78a.65.65,0,0,0,.49-.17.75.75,0,0,0,0-.88.43.43,0,0,0-.33-.15.44.44,0,0,0-.34.17.85.85,0,0,0-.18.5l-.72-.15a1.7,1.7,0,0,1,.44-1,1.18,1.18,0,0,1,.83-.31,1.12,1.12,0,0,1,.89.4,1.36,1.36,0,0,1,.33.89,1.2,1.2,0,0,1-.15.59,1.51,1.51,0,0,1-.45.46.94.94,0,0,1,.56.4,1.34,1.34,0,0,1,.22.79,1.6,1.6,0,0,1-.41,1.14,1.29,1.29,0,0,1-1.89.07A1.63,1.63,0,0,1,82.59,77.71Z",
  fill: "#231f20"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M87.35,79V78H85.67v-.84L87.45,74h.66v3.18h.51V78h-.51v1Zm0-1.85V75.48l-.94,1.71Z",
  fill: "#231f20"
});

var SvgSensorLabel = function SvgSensorLabel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 190 120",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "b455252f-9f05-45b5-ab59-dddb208e27de",
    "data-name": "Layer 1"
  }, _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("path", {
    d: "M166.58,4.69H185a0,0,0,0,1,0,0V44.91a0,0,0,0,1,0,0H170.18a3.6,3.6,0,0,1-3.6-3.6V4.69a0,0,0,0,1,0,0Z",
    transform: "translate(351.58 49.6) rotate(-180)",
    fill: "url(#f6e529ff-eadc-40d4-be5e-fb2a7ac942ca)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.18,47.81H185a0,0,0,0,1,0,0v67.5a0,0,0,0,1,0,0H166.58a0,0,0,0,1,0,0V51.41a3.6,3.6,0,0,1,3.6-3.6Z",
    transform: "translate(351.58 163.12) rotate(-180)",
    fill: "url(#bb033e55-9792-4ed7-9cdf-cbc9b0118e77)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6,4.69H23.42a0,0,0,0,1,0,0V44.91a0,0,0,0,1,0,0H5a0,0,0,0,1,0,0V8.29a3.6,3.6,0,0,1,3.6-3.6Z",
    fill: "url(#a946cd15-edde-45a0-a7b1-a58230f294fb)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,47.81H23.42a0,0,0,0,1,0,0v67.5a0,0,0,0,1,0,0H8.6a3.6,3.6,0,0,1-3.6-3.6V47.81A0,0,0,0,1,5,47.81Z",
    fill: "url(#bb24b2ff-3ffc-41b2-9d27-32635903b993)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref7, /*#__PURE__*/React.createElement("image", {
    width: 281,
    height: 280,
    transform: "translate(28.54 21.1) scale(0.24)",
    opacity: 0.25,
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSensorLabel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sensor-label.ea154556.svg";
export { ForwardRef as ReactComponent };